<template>
  <div class="flex flex-col items-center justify-center py-12">
    <Loader2 class="w-8 h-8 animate-spin text-gray-400 mb-4" />
    <p class="text-gray-600">Processing your payment...</p>
  </div>
</template>

<script setup lang="ts">
import { Loader2 } from 'lucide-vue-next'
</script>
